export const LEFT_ANCHOR_POPOVER_ORIGINS = {
  anchorOrigin: { vertical: 'center' as const, horizontal: 'left' as const },
  transformOrigin: { vertical: 'center' as const, horizontal: 'right' as const },
};

export function leftAnchorPopoverPaperSx(
  dark: boolean,
  width: object | string | number = { xs: 'min(calc(100vw - 48px), 320px)', sm: 360 }
) {
  const borderColor = dark ? 'rgba(255,255,255,0.18)' : 'divider';
  const bg = dark ? '#2a2a2a' : 'background.paper';

  return {
    width,
    maxWidth: 'none',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'visible',
    border: '1px solid',
    borderColor,
    bgcolor: bg,
    boxShadow: dark ? '0 12px 40px rgba(0,0,0,0.55)' : 8,
    mr: 0.5,
    '&::after': {
      content: '""',
      position: 'absolute',
      right: -7,
      top: '50%',
      transform: 'translateY(-50%) rotate(45deg)',
      width: 14,
      height: 14,
      bgcolor: bg,
      borderTop: '1px solid',
      borderRight: '1px solid',
      borderColor,
    },
  } as const;
}
